<template>
  <div style="width:100%;float:left;position:relative;">
    <div style="width:100%;float:left;">
      <CCard border-color="danger" v-if="pdf.customer_info.on_hold">
        <CCardBody style="text-align:center;color:red;">
          {{pdf.customer_info.customer_name}} account is on credit hold.
        </CCardBody>
      </CCard>
      <CCard>
        <CCardBody>
          <div style="width:100%;float:left;" v-if="$store.state.user.menuroles.indexOf('csr_admin') > -1 || $store.state.user.menuroles.indexOf('admin') > -1">
            <!-- <select class="form-control" style="width:200px;float:right;" v-model="pdf.as400_status" @change="groupStatusChanged()">
              <option v-for="status in statuses" :value="status">{{status}}</option>
            </select> -->
            <button class="btn btn-danger" style="width:200px;float:right;" @click="groupStatusVoid()" v-if="Number(pdf.as400_status_code) !== 8">VOID ORDER</button>
          </div>
          <div style="width:100%;float:left;" v-if="pdf">
            <div style="width:100%;float:left;">
              <div class="progress-group">
                <div class="progress-group-header">
                  <span class="title">Order Status: {{pdf.as400_status}}</span>
                  <!-- <span class="ml-auto font-weight-bold">
                    {{pdf.as400_status}}</span>
                  </span> -->
                </div>
                <!-- <div class="progress-group-bars">
                  <CProgress
                    class="progress-md"
                    :value="configureStatus()"
                    :color="configureStatusColor()"
                  />
                </div> -->
              </div>
            </div>
            <!-- <div style="width:100%;float:left;" v-if="$store.state.user.user_type === 'csr'">
              <div class="progress-group">
                <div class="progress-group-header">
                  <span class="title">CSR Folder Status: {{pdf.csr_status}}</span> -->
                  <!-- <span class="ml-auto font-weight-bold">
                    {{pdf.as400_status}}</span>
                  </span> -->
                <!-- </div>
                <div class="progress-group-bars">
                  <CProgress
                    class="progress-md"
                    :value="configureCsrColor() ? 100 : 0"
                    :color="configureCsrColor()"
                  />
                </div>
              </div>
            </div> -->
            <div class="col-12 float-left mb-3" v-if="$store.state.user.user_type !== 'rep'">
              <order-cc :group="pdf"></order-cc>
            </div>
            <!-- <div style="width:100%;float:left;margin-bottom:15px;"> -->
            <div class="col-sm-12 text-center float-left" v-if="configureButtons(pdf) && $store.state.user.user_type !== 'rep'">
              <CButton size="sm" class="m-1 float-left" color="success" @click="generate('artpacks', pdf)" v-if="configureButtonType(pdf, 'artpacks')">Generate Artpack(s)</CButton>
              <CButton size="sm" class="m-1 float-left" color="success" @click="generate('escapes', pdf)">Generate Escape</CButton>
              <!-- <CButton size="sm" class="m-1 float-left" color="success" @click="generate('order_entries', pdf)">Generate OE</CButton> -->
              <CButton size="sm" class="m-1 float-left" color="info" @click="generate('components', pdf)" v-if="configureButtonType(pdf, 'components')">Generate Component(s)</CButton>
              <CButton size="sm" class="m-1 float-left" color="danger" @click="generate('embroideries', pdf)" v-if="configureButtonType(pdf, 'embroideries')">Generate Embroidery</CButton>
              <CButton size="sm" class="m-1 float-left" color="warning" @click="generate('heat_seals', pdf)" v-if="configureButtonType(pdf, 'heat_seals')">Generate Heat Seal(s)</CButton>

              <spacer />
            </div>
            <CCol col="12" class="float-left mb-3">
              <label><b>{{pdf.customer_info.customer_name}}</b></label>
            </CCol>
            <CCol col="12" class="float-left mb-3">
              <label><b>Log #:</b> {{pdf.as400_log_number}}</label>
            </CCol>
            <CCol v-if="netSuite && pdf.as400_status !== 'Closed'" col="12" class="float-left mb-3">
              <label><b>CC #:</b> {{netSuite.tranid || "CC number will appear when created."}}</label>
            </CCol>
            <CCol v-if="netSuite && pdf.as400_status !== 'Closed'" col="12" class="float-left mb-3">
              <label><b>Tracking #: </b> 
                <a
                  v-if="netSuite.tracking"
                  :href="getTrackingLink(netSuite.tracking)"
                  target="_blank">{{netSuite.tracking}}</a>
                <span v-else>Tracking number will appear when shipped. </span>
                </label>
            </CCol>
            <CCol col="12" class="float-left mb-3">
              <label><b>Invoice #: </b>
                <span v-if="netSuite && pdf.as400_status !== 'Closed'">
                  <CLink @click="popupInvoice()">{{ netSuite.invoice_number || '' }}</CLink>
                </span>
                <span v-else>
                  Invoice number will appear when invoiced.
                </span>
              </label>
            </CCol>

            <!-- <CCol col="12" class="float-left mb-3">
              <CButton size="sm" color="secondary" v-if="!downloadLoading" @click="downloadFiles()">Download Order File(s)</CButton>
              <small-loader v-else></small-loader>
            </CCol> -->
            <spacer />
            <div style="width:100%;float:left;" v-if="$store.state.user.user_type !== 'csr'">
              <!-- <pdf-view :form="pdf" :type="0"></pdf-view> -->
              <div style="width:100%;float:left;text-align:center;margin-bottom:15px;" v-if="pdf.original_pdf_id">
                <!-- <CButton size="sm" color="warning" @click="adobeBring('editFull')">Edit PDF Full Screen</CButton> -->
                <CButton size="sm" color="info" class='ml-2' @click="adobeBring('viewOriginal')">View Original PDF Full Screen</CButton>
              </div>
              <div style="width:100%;float:left;" v-if="pdf.original_pdf_id">
                <adobe-pdf-viewer v-if="pdf.original_pdf_id && !adobeReload && !editFull && !viewOriginal" :repView="true" :otherClass="'in_pdf_order'" :order_group="pdf" :pdf_type="'original'" :allowEdit="false"></adobe-pdf-viewer>
                <adobe-pdf-viewer v-else-if="viewOriginal && !adobeReload" @closed="adobeClosed()" :repView="true" :order_group="pdf" :pdf_type="'original'" :allowEdit="false"></adobe-pdf-viewer>
                <small-loader v-if="adobeReload"></small-loader>
              </div>
              <div style="width:100%;float:left;" v-else>
                <pdf-view :fromSummary="true" :form="pdf" :type="0"></pdf-view>
              </div>
              
            </div>
            <div style="width:100%;float:left;" v-else>
              <div style="width:100%;float:left;text-align:center;margin-bottom:15px;" v-if="pdf.original_pdf_id">
                <CButton size="sm" color="warning" @click="adobeBring('editFull')">Edit PDF Full Screen</CButton>
                <CButton size="sm" color="info" class='ml-2' @click="adobeBring('viewOriginal')">View Original PDF</CButton>
              </div>
              <div style="width:100%;float:left;" v-if="pdf.original_pdf_id || $store.state.user.user_type === 'csr' || $store.state.user.user_type === 'admin'">
                <adobe-pdf-viewer v-if="pdf.original_pdf_id && !adobeReload && !editFull && !viewOriginal" :otherClass="'in_pdf_order'" :order_group="pdf" :pdf_type="'current'" :allowEdit="true"></adobe-pdf-viewer>
                <adobe-pdf-viewer v-else-if="editFull && !adobeReload" @closed="adobeClosed()" :order_group="pdf" :pdf_type="'current'" :allowEdit="true"></adobe-pdf-viewer>
                <adobe-pdf-viewer v-else-if="viewOriginal && !adobeReload" @closed="adobeClosed()" :order_group="pdf" :pdf_type="'original'" :allowEdit="false"></adobe-pdf-viewer>
                <small-loader v-if="adobeReload"></small-loader>
                <pdf-view v-if="!pdf.original_pdf_id" :fromSummary="true" :form="pdf" :type="0"></pdf-view>
              </div>
              <div style="width:100%;float:left;text-align:center;" v-else>
                <!-- <pdf-view :fromSummary="true" :form="pdf" :type="0"></pdf-view> -->
                 Your pdf will be generated here shortly and automatically emailed to you.. Please hit click the button to refresh if you would like to see if it's generated.<br />
                 <CButton size="sm" color="info" @click="refresh()">Refresh</CButton>
              </div>

            </div>
          </div>
          <small-loader v-else-if="currentLoading"></small-loader>
        </CCardBody>
      </CCard>
    </div>

    <CModal
      title="Generate Request"
      :show.sync="generateModal"
      size="xl">
      <div style="width:100%;float:left;" v-if="generateGroup">
        <component-request v-if="generateType === 'components'" @submitted="submitChange" :group="generateGroup" :newData="form"></component-request>
        <escape-request v-if="generateType === 'escapes'" @submitted="submitChange" :group="generateGroup" :newData="form"></escape-request>
        <artpack-request v-if="generateType === 'artpacks'" @submitted="submitChange" :group="generateGroup" :newData="form"></artpack-request>
        <embroidery-request v-if="generateType === 'embroideries'" @submitted="submitChange" :group="generateGroup" :newData="form"></embroidery-request>
        <heat-seal-request v-if="generateType === 'heat_seals'" @submitted="submitChange" :group="generateGroup" :newData="form"></heat-seal-request>
      </div>
      <template #footer>
        <div style="width:100%;float:left;"> </div>
      </template>
    </CModal>

    <customer-invoice v-if="invoiceData && invoiceModal" @close="invoiceData = null, invoiceModal = false" :invoiceData="invoiceData"></customer-invoice>
    
  </div>
</template>
<script>
import PdfView from './../components/pdf_view'
import AdobePdfViewer from './../components/adobe_pdf_viewer'
import EscapeRequest from './../flow/escape_request'
import ArtpackRequest from './../flow/artpack_request'
import EmbroideryRequest from './../flow/embroidery_request'
import ComponentRequest from './../flow/component_request'
import HeatSealRequest from './../flow/heat_seal_request'
import CustomerInvoice from './../reports/customer_invoice'
// import NetsuiteDisplay from './netsuite_display'
const OrderCc = () => import('./../orders/order_cc.vue')
var methods = {}

methods.adobeClosed = function () {
  this.editFull = false
  this.viewOriginal = false
  this.adobeReload = true
  var that = this
  setTimeout(function () {
    that.adobeReload = false
  }, 1000)
}

methods.refresh = function () {
  window.location.reload();
}

methods.getTrackingLink = function (tracking) {
  if (tracking.substr(0, 2) == '1Z') {
    return 'https://wwwapps.ups.com/WebTracking/track?loc=en_US&track.x=Track&trackNums=' + tracking
  } else {
    return 'https://www.fedex.com/fedextrack/?trknbr=' + tracking
  }
}

methods.adobeBring = function (t) {
  console.log('adobe bring')
  this.adobeReload = true
  var that = this
  setTimeout(function () {
    that[t] = true
    that.adobeReload = false
  }, 1000)
}

methods.configureCsrColor = function () {
  var that = this
  var color = ''
  if (this.pdf) {
    var statuses = [
      {header: 'good_to_go', text: "Good To Go", color: 'success', status: 'Good To Go'},
      {header: 'send_to_art', text: "Send To Art/World Emblem", color: 'danger', status: 'Send To Art/World Emblem'},
      {header: 'hold', text: "Hold/Sent For Approval", color: 'warning', status: 'Hold/Sent For Approval'},
      {header: 'events', text: "Events-Check Shipping", color: 'info', status: 'Events-Check Shipping'},
    ]
    statuses.forEach(function (status) {
      if (status.status === that.pdf.csr_status) {
        color = status.color
      }
    })
  }
  return color
}

// methods.groupStatusChanged = function () {
//   const postData = {
//     group: this.pdf
//   }
//   axios.post(this.$apiAdress + '/api/orders/groupStatusChanged?token=' + localStorage.getItem('api_token'), postData).then(response => {

//   })
// }

methods.groupStatusVoid = function () {
  window.Swal.fire({
    title: 'Void Order?',
    text: 'Are you sure you want to void this order?',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, void it',
    cancelButtonText: 'Cancel'
  }).then(result => {
    if (result.value) {
      const postData = {
        group: this.pdf
      }

      axios.post(
        this.$apiAdress + '/api/orders/groupStatusVoid?token=' + localStorage.getItem('api_token'),
        postData
      ).then(response => {
        this.pdf.as400_status_code = '8'
        this.pdf.as400_status = 'Voided'
      })
    }
  })
}

methods.submitChange = function () {
  this.generateModal = false
  this.generateGroup = null
  this.generateType = ''
  window.Swal.fire({
    type: 'success',
    title: 'Success!',
    text: 'You have successfully entered the request.'
  })
}

// methods.configureStatusColor = function () {
//   if (this.pdf) {
//     var percent = ''
//     switch(this.pdf.as400_status) {
//       case 'Entered': {
//         percent = 'info'
//         break
//       }
//       case 'Received': {
//         percent = 'info'
//         break
//       }
//       case 'Closed': {
//         percent = 'info'
//         break
//       }
//       case 'In Process': {
//         percent = 'danger'
//         break
//       }
//       case 'Shipped': {
//         percent = 'success'
//         break
//       }
//       case 'On Hold': {
//         percent = 'warning'
//         break
//       }
//       case 'Voided': {
//         percent = 'warning'
//         break
//       }
//       case 'Canceled': {
//         percent = 'danger'
//         break
//       }
//       default: {
//         percent = ''
//         break
//       }
//     }
//     return percent
//   } else {
//     return 0
//   }
// }

// methods.configureStatus = function () {
//   if (this.pdf) {
//     var percent = ''
//     switch(this.pdf.as400_status) {
//       case 'Entered': {
//         percent = 10
//         break
//       }
//       case 'Received': {
//         percent = 33
//         break
//       }
//       case 'In Process': {
//         percent = 66
//         break
//       }
//       case 'Shipped': {
//         percent = 100
//         break
//       }
//       case 'On Hold': {
//         percent = 50
//         break
//       }
//       case 'Voided': {
//         percent = 100
//         break
//       }
//       case 'Canceled': {
//         percent = 100
//         break
//       }
//       default: {
//         percent = 0
//         break
//       }
//     }
//     return percent
//   } else {
//     return 0
//   }
// }

methods.generate = function (type, val) {
  this.generateType = type
  this.generateGroup = val
  this.generateModal = true
}

methods.configureButtonType = function (value, type) {
  var t = false
  value.order_items.forEach(function (item) {
    console.log(item)
    item.order_item_locations.forEach(function (location) {
      if (location.decoration) {
        if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
          if (type !== 'artpacks') {
            if (location.technique.type === type) {
              t = true
            }
          } else {
            if (location.new_decoration) {
              t = true
            }
          }
        }
      }
    })
  })
  return t
}

methods.configureButtons = function (value) {
  console.log('configure buttons')
  console.log(value)
  var t = false
  if (value.cc_number) {
    t = true
    // value.order_items.forEach(function (item) {
    //   console.log(item)
    //   item.order_item_locations.forEach(function (location) {
    //     if (location.decoration.req_type === 'artpacks' || location.new_decoration) {
    //       t = true
    //     }
    //   })
    // })
  }
  return t
}

methods.getNetSuiteOrder = function () {
  console.log('pdf internal id ==', this.pdf.internal_id)
  axios.get(this.$apiAdress + '/api/reports/getOrderById?id='+this.pdf.internal_id+'&token=' + localStorage.getItem('api_token')).then(response => {
    console.log('NETSUITE ORDERssss')
    console.log(response)
    if (response.data.items[0].status === 'Cancelled') {
      this.pdf.as400_status = 'Canceled'
    }
    this.netSuite = response.data.items[0]
    // set value of status using this NS query order_status_label..
    const orderStatus = String(this.netSuite.order_status_label || '').replace(/^[^:]*:\s*/, '').trim()

    this.pdf.as400_status = orderStatus
  })
}

methods.popupInvoice = function () {
  this.invoiceData = { invoice_number: this.netSuite.invoice_number };

  this.invoiceModal = true;
}

export default {
    // ===Component name
    name: "PdfDisplay",
    // ===Props passed to component
    props: ['pdf', 'form', 'fromSummary'],
    // ===Components used by this component
    components: {
    	PdfView,
      OrderCc,
      EscapeRequest,
      ArtpackRequest,
      EmbroideryRequest,
      ComponentRequest,
      HeatSealRequest,
      AdobePdfViewer,
      CustomerInvoice
      // NetsuiteDisplay
    },
    // ====component Data properties
    data(){
        return{
        	data: null,
          pdfs: [],
          // form: null,
          current: null,
          currentIndex: 0,
          currentLoading: false,
          generateType: '',
          generateGroup: '',
          generateModal: false,
          editFull: false,
          viewOriginal: false,
          adobeReload: false,
          netSuite: null,
          downloadLoading: false,
          statuses: [
            'Needs Entered',
            'Received',
            'On Hold',
            'Voided',
            // 'Canceled',
          ],
          invoiceData: null,
          invoiceModal: false,
        }
    },
    // ===Code to be executed when Component is mounted
    mounted() {
      console.log('PDF CONTENT')
      console.log(this.pdf)
      // if (this.pdf.internal_id) {
        this.getNetSuiteOrder()
      // }
    	// this.getOrder()
    	// this.getPdfData(this.form)
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped lang="scss">
	span.cls_002{font-family:Arial,serif;font-size:9.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_002{font-family:Arial,serif;font-size:9.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_003{font-family:Arial,serif;font-size:11.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_003{font-family:Arial,serif;font-size:11.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_004{font-family:Arial,serif;font-size:8.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_004{font-family:Arial,serif;font-size:8.3px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_005{font-family:Arial,serif;font-size:15.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_005{font-family:Arial,serif;font-size:15.1px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_006{font-family:Arial,serif;font-size:10.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_006{font-family:Arial,serif;font-size:10.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	span.cls_007{font-family:Arial,serif;font-size:9.8px;color:rgb(0,0,0);font-weight:bold;font-style:normal;text-decoration: none}
	div.cls_007{font-family:Arial,serif;font-size:9.8px;color:rgb(0,0,0);font-weight:bold;font-style:normal;text-decoration: none}
	span.cls_008{font-family:Arial,serif;font-size:6.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}
	div.cls_008{font-family:Arial,serif;font-size:6.0px;color:rgb(0,0,0);font-weight:normal;font-style:normal;text-decoration: none}

</style>
